// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-a0b684ce] {\n  font-size: 14px;\n  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n}\nh3[data-v-a0b684ce] {\n  font-size: 10px;\n}\n@media only screen and (min-width: 768px) {\nh1[data-v-a0b684ce] {\n    font-size: 55px;\n    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n}\nh3[data-v-a0b684ce] {\n    font-size: 30px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
